import { render, staticRenderFns } from "./FormInputCheckbox.vue?vue&type=template&id=23008d11"
import script from "./FormInputCheckbox.vue?vue&type=script&lang=js"
export * from "./FormInputCheckbox.vue?vue&type=script&lang=js"
import style0 from "./FormInputCheckbox.vue?vue&type=style&index=0&id=23008d11&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports